import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import {LoadingIcon} from "@ergeon/erg-components-react";

const Loading = (props) => {
  const {className: additionalClassName, inForm, style} = props;
  const className = classnames(additionalClassName, "text-muted", {
    "erg-padding-15": !inForm,
    "form-control-static": inForm,
  });
  return (
    <div className={className} style={style}>
      <LoadingIcon />
    </div>
  );
};

Loading.defaultProps = {
  inForm: false,
  style: {},
};
Loading.propTypes = {
  className: PropTypes.string,
  inForm: PropTypes.bool,
  style: PropTypes.object,
};

export default Loading;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/Loading.js
 **/